<script>
    import { term } from "./../utils/store.js";

    let val = "";
    $: term.set(val);
</script>

<div class="search">
    <form>
        <div class="search_input">
            <input type="text" placeholder="Search..." bind:value={val} />
            <button type="submit"><i class="fas fa-search" /></button>
        </div>
    </form>
</div>
